import { useMemo } from "react";
import { useSelector } from "react-redux";

import { httpResponseSelector } from "../../../services/general/selectors";

const useHttpResponse = () => {
    const response = useSelector(httpResponseSelector);

    return useMemo(
        () => response.map(({ http_response_content, url, http_response_code }) => ({
            html: http_response_content,
            url,
            http_response_code
        })),
        [ response ]
    );
};

export default useHttpResponse;
